exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:768px){.events-eventscardsslider-component>*{padding-right:0!important;padding-left:0!important}}.events-eventscardsslider-component .well{height:420px}@media (max-width:768px){.events-eventscardsslider-component .well{padding-right:0!important;padding-left:0!important}}.events-eventscardsslider-component__title-wrap{padding:0 16px 48px}.events-eventscardsslider-component__slider{margin-top:-48px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/events/eventscardsslider.scss
// module id = 1020
// module chunks = 0